import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './PublicMobileMenu.css';

const LINKS = [
  ['home', '/', 'الرئيسية'],
  ['founder', '/founder', 'المؤسس'],
  ['how-it-works', '/how-it-works', 'كيف يعمل'],
  ['subscribe', '/subscribe', 'اشترك معنا'],
  ['feedback', '/feedback', 'رأيك يهمنا'],
  ['login', '/login', 'تسجيل الدخول'],
];

export const PublicMobileMenu = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const container = useRef(null);
  const button = useRef(null);

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const closeOnDesktop = event => { if (event.matches) setOpen(false); };
    desktop.addEventListener('change', closeOnDesktop);
    return () => desktop.removeEventListener('change', closeOnDesktop);
  }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = event => {
      if (event.key === 'Escape') { setOpen(false); button.current?.focus(); }
    };
    const onOutside = event => { if (!container.current?.contains(event.target)) setOpen(false); };
    document.addEventListener('keydown', onKey);
    document.addEventListener('pointerdown', onOutside);
    return () => { document.removeEventListener('keydown', onKey); document.removeEventListener('pointerdown', onOutside); };
  }, [open]);

  return <div className="public-mobile-menu" ref={container}>
    <button ref={button} type="button" className="public-mobile-toggle" onClick={() => setOpen(value => !value)} aria-label={open ? 'إغلاق القائمة' : 'فتح القائمة'} aria-expanded={open} aria-controls="public-mobile-navigation" data-testid="public-mobile-menu-toggle">
      {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
    </button>
    {open && <nav id="public-mobile-navigation" className="public-mobile-panel" dir="rtl" aria-label="القائمة الرئيسية" data-testid="public-mobile-navigation">
      {LINKS.map(([key, path, label]) => <Link key={key} to={path} aria-current={pathname === path ? 'page' : undefined} onClick={() => setOpen(false)} data-testid={`public-mobile-link-${key}`}>{label}</Link>)}
    </nav>}
  </div>;
};